import ReactDOM from 'react-dom';
import { ThemeProvider } from '@capitalise/ui-design-system';
import ErrorBoundary from 'modules/ErrorBoundary';

import GlobalStyle from './global-styles';
import React from 'react';
const Main = React.lazy(() => import('./Main'));

const MOUNT_NODE = document.getElementById('app');

const render = () => {
  ReactDOM.render(
    <>
      <ThemeProvider>
        <ErrorBoundary>
          <React.Suspense fallback="">
            <Main />
          </React.Suspense>
        </ErrorBoundary>
      </ThemeProvider>
      <GlobalStyle />
    </>,
    MOUNT_NODE,
  );
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['modules/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    render(require('./modules/App').default);
  });
}

render();
